const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const MasterDataQuery: any = {
    GetPlatforms: `${Backofficebff}/v1/globaldata/platform-list`,
    GetCountryList: `${Backofficebff}/v1/masterdata/getcountrylist`,
};
